import { render, staticRenderFns } from "./ProductionStatLong.view.vue?vue&type=template&id=064e1f0e&"
import script from "./ProductionStatLong.view.vue?vue&type=script&lang=js&"
export * from "./ProductionStatLong.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports